import React, { Component } from 'react'

class SvgFile extends Component {
  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="12"
        viewBox="0 0 16 12"
      >
        <g fill="none" fillRule="evenodd">
          <path d="M21-7H-4v25h25z" />
          <g fill="#5B6982" fillRule="nonzero">
            <path d="M15 6.833H1.667a.833.833 0 1 1 0-1.666H15a.833.833 0 1 1 0 1.666z" />
            <path d="M7.256 10.41a.833.833 0 0 1-1.179 1.18l-5-5a.833.833 0 0 1 0-1.18l5-5a.833.833 0 1 1 1.179 1.18L2.846 6l4.41 4.41z" />
          </g>
        </g>
      </svg>
    )
  }
}

export default SvgFile
